<div class="pin-input-wrapper">
  <div class="pin-container">
    <input 
      #pinInput 
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[0]" 
      [disabled]="loading" 
      [autofocus]="true" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 0)"
    >
    <input 
      #pinInput 
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[1]" 
      [disabled]="loading" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 1)"
    >
    <input 
      #pinInput 
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[2]" 
      [disabled]="loading" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 2)"
    >
    <input 
      #pinInput 
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[3]" 
      [disabled]="loading" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 3)"
    >
    <input 
      #pinInput 
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[4]" 
      [disabled]="loading" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 4)"
    >
    <input 
      #pinInput
      [ngClass]="{'error': hasError, 'password-mode': !showPin}" 
      [(ngModel)]="displayPin[5]" 
      [disabled]="loading" 
      type="tel"
      maxlength="1" 
      (keydown)="handleKeyDown($event, 5)"
    >
  </div>
  
  <button 
    *ngIf="showToggleVisibility"
    type="button"
    class="toggle-visibility-btn"
    (click)="toggleShowPin()"
    [disabled]="loading"
    [attr.aria-label]="showPin ? 'Ocultar PIN' : 'Mostrar PIN'"
  >
    <img 
      [src]="showPin ? 'assets/icons/ico_closed_eye.svg' : 'assets/icons/ico_open_eye.svg'"
      width="16" height="16" alt=""
    />
  </button>
</div>
